import { render, staticRenderFns } from "./MsComboBoxItem.vue?vue&type=template&id=934a6c5c&scoped=true"
import script from "./MsComboBoxItem.vue?vue&type=script&lang=js"
export * from "./MsComboBoxItem.vue?vue&type=script&lang=js"
import style0 from "./MsComboBoxItem.vue?vue&type=style&index=0&id=934a6c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934a6c5c",
  null
  
)

export default component.exports